/*
  Box value line.

  Shows a line of text that depends on which value is selected for one product
  option, for example "over $300 of product" for the $200 box. The theme
  re-renders only a fixed set of ids on variant change and never this block, so
  this listens for the variantChange event and swaps the text itself.
*/
if (!customElements.get('mystery-value')) {
  customElements.define(
    'mystery-value',
    class MysteryValue extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('[data-mystery-value-text]');
        this.optionIndex = parseInt(this.dataset.optionIndex, 10);
        if (!this.textEl || isNaN(this.optionIndex)) return;

        this.values = this.parseMap();
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        var self = this;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var data = event && event.data;
          if (!data || data.sectionId !== self.dataset.sectionId) return;
          self.update(data.variant);
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      /* "option value = text" per line, the same format the block setting uses. */
      parseMap() {
        var el = this.querySelector('[data-mystery-value-map]');
        var raw = '';
        try {
          raw = JSON.parse(el.textContent);
        } catch (e) {
          return {};
        }
        var out = {};
        String(raw)
          .split(/\r?\n/)
          .forEach(function (line) {
            var at = line.indexOf('=');
            if (at > 0) out[line.slice(0, at).trim()] = line.slice(at + 1).trim();
          });
        return out;
      }

      update(variant) {
        var selected = variant && variant.options ? variant.options[this.optionIndex] : null;
        var text = selected ? this.values[selected] : null;
        // A value with no line of its own simply shows nothing.
        this.hidden = !text;
        if (text) this.textEl.textContent = text;
      }
    }
  );
}
